module.exports = __webpack_public_path__ + "static/media/W5390484_22.c3efd18a.jpg";